<template>
    <div class="main-box">
        <div class="main-container">
            <el-row>
                <el-col :span="18" class="left-container" v-loading="loading" :offset="hiddenAll?3:0">
                    <div class="container" v-if="!empty">
                        <div class="header">
                            <div class="title">
                                <span class="urgent" v-if="post.urgentFlag === 1">急</span>
                                {{post.postName}}
                                <div class="salary" v-if="[null, '', undefined].indexOf(post.minimalSalary) === -1 &&
                                    [null, '', undefined].indexOf(post.maximumSalary) === -1 && [null, '', undefined].indexOf(post.salaryMonth) === -1">
                                    {{(post.minimalSalary === 0 && post.maximumSalary === 0)?'':(post.minimalSalary + '-' + post.maximumSalary + 'K·' + post.salaryMonth + '薪')}}
                                </div>
                            </div>
                            <div class="status">
                                <span class="item" v-if="post.area" v-html="post.area.areaName"></span>
                                <span class="item" v-if="post.postType" v-html="post.postType.postTypeName"></span>
                                <span class="item" v-if="post.org" v-html="post.org.orgName"></span>
                                <span class="status-item" v-if="post.demandNumber" v-html="post.demandNumber + '人'"></span>
                            </div>
                            <el-button class="btn" type="primary" size="small" @click="notifyConfirm">申请职位</el-button>
                        </div>
                        <div class="content">
                            <div class="title">
                                <span class="describe">职位描述</span>
                            </div>
                            <div class="duty" v-if="post.duty">工作职责：</div>
                            <div>
                                <p class="detailed" v-for="text of post.duty" :key="text" v-html="text"></p>
                            </div>
                            <div class="requirement" v-if="post.requirement">任职要求：</div>
                            <div>
                                <p class="detailed" v-for="text of post.requirement" :key="text" v-html="text"></p>
                            </div>
                        </div>
                        <div class="footer">
                            <el-button @click="notifyConfirm" size="small" type="primary">申请职位</el-button>
                        </div>
                    </div>
                    <div class="container" v-if="empty">
                        <el-empty description="抱歉，该职位已停止招聘，去看看其他机会吧！">
                            <el-button type="primary" size="small" @click="otherPostClick">查看其他岗位</el-button>
                        </el-empty>
                    </div>
                </el-col>
                <el-col :span="6" class="right-container" v-if="!hiddenAll">
                    <NewestPost :channelType="post.recruitmentFaceToType"></NewestPost>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
import NewestPost from './components/NewestPost.vue';
import api from '@/api';
export default {
    name: 'PostDetail',
    components: {
        NewestPost
    },
    data() {
        return {
            textareaText: '',
            loading: false,
            empty: false,
            post: {
                recruitmentFaceToType: 1,
                duty: [],
                requirement: []
            },
            hiddenAll: !!this.$store.state.promoterId
        };
    },
    created() {
        this.getDetailByPostId(this.$route.params.id);
    },
    mounted() {
    },
    methods: {
        // 根据ID获取岗位详情
        async getDetailByPostId(id) {
            this.loading = true;
            const res = await api.post.getDetailByPostId(id);
            this.loading = false;
            if (res.code !== 200 || !res.data) {
                this.empty = true;
                return;
            }
            res.data.duty = res.data.duty ? res.data.duty.split(/[(\r\n)\r\n]+/) : [];
            res.data.requirement = res.data.requirement ? res.data.requirement.split(/[(\r\n)\r\n]+/) : [];
            this.post = res.data;
        },
        notifyConfirm() {
            const h = this.$createElement;
            this.$msgbox({
                title: '候选人告知书',
                message: h('div', { style: 'line-height: 1.5' }, [
                    h('div', null, '亲爱的候选人您好，请在确认申请职位之前，务必认真阅读并透彻理解以下隐私政策条款，一旦您确认提交，即表示您已充分理解并同意以下条款。'),
                    h('div', { style: 'padding-top: 10px' }, '1）您通过本招聘平台求职时，可上传您的简历并表达您对职位的求职意向。我们会收集您的以下信息：姓名、性别、年龄、出生日期、证件号码、现居住地、户籍所在地、民族、政治面貌、教育背景、手机号码和邮箱、工作经历、项目经历、照片信息、紧急联系人（您应保证向我们提供紧急联系人信息之前已经就此取得了该紧急联系人的同意）的联系方式等敏感信息，以及您主动提供的其他信息（包括内推信息等）。'),
                    h('div', { style: 'padding-top: 10px' }, '2）我们收集上述信息仅用于员工招聘，我们会使用您提交的简历信息进行相关的人员甄选和招聘活动，在这个过程中我们的HR或者面试官可能会与您进行电话沟通以便进行面试邀约或者进行其他招聘活动过程中所必要的沟通和交流。我们将会在本条款所涵盖的用途内使用收集的信息。如我们使用您的个人信息，超出了于收集时所声称的目的及具有直接或合理关联的范围，我们将在使用您的个人信息前，再次向您告知并征得您的明示同意。'),
                    h('div', { style: 'padding-top: 10px' }, '3）一般而言，我们仅会为实现员工招聘目的所必需的最短时间保留您的个人信息，超出上述期限后，我们将删除您的个人信息或对您的个人信息进行匿名化处理。'),
                    h('div', { style: 'padding-top: 10px' }, '4）本招聘平台系璞泰来集团名下多家子公司及关联公司共同使用，我们可将您基于求职目的而提交的信息与璞泰来集团及子公司和关联公司共享，共享用途亦仅用于员工招聘。')
                ]),
                customClass: 'max-box',
                showCancelButton: true,
                confirmButtonText: '我已阅读上述内容',
                cancelButtonText: '取消'
            }).then(action => {
                this.applyPost();
            });
        },
        // 申请岗位
        applyPost() {
            let url = '/post/' + this.$route.params.id + '/apply';
            if (this.$store.state.promoterId) {
                url += '?promoterId=' + this.$store.state.promoterId;
            }
            this.$router.push(url);
        },
        // 查看更多岗位点击
        otherPostClick() {
            if (sessionStorage.getItem('ptlPageType')) {
                this.$router.push('/' + sessionStorage.getItem('ptlPageType') + '/job');
            } else {
                this.$router.push('/job/' + (this.post.recruitmentFaceToType === 1 ? 'social' : this.post.recruitmentFaceToType === 2 ? 'campus' : 'worker'));
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.main-box {
    overflow: auto;
    position: relative;
    height: 100%;
    border-top: 80px solid #00003C;
    box-sizing: border-box;
}
.main-container {
    margin-top: 30px;
    width: 1200px;
    min-width: 1200px;
    height: 100%;
    box-sizing: border-box;
    margin: auto;
}
.left-container, .right-container {
    padding: 0 8px;
    margin-top: 30px;
}
.left-container {
    .container {
        background: #fff;
        padding: 20px 30px;
    }
    .header {
        position: relative;
        margin-bottom: 16px;
        .title {
            font-size: 20px;
            line-height: 28px;
            color: #222831;
            margin-right: 120px;
            font-weight: 600;
            position: relative;
            .salary {
                position: absolute;
                color: #ff6b6b;
                font-size: 16px;
                line-height: 28px;
                right: -120px;
                top: 0;
            }
        }
        .status {
            margin-top: 15px;
            margin-right: 96px;
            color: #89909e;
            .item {
                padding: 0 10px;
                border-right: 1px solid #dddfe3;
            }
            .item:first-child {
                padding-left: 0;
            }
            .item:last-child {
                border-right: none;
            }
        }
        .btn {
            position: absolute;
            bottom: 0;
            right: 0;
        }
    }
    .content {
        .title {
            margin-bottom: 19px;
            color: #222831;
            font-size: 16px;
            position: relative;
            height: 24px;
            .describe {
                background: #fff;
                position: absolute;
                left: 0;
                z-index: 2;
                padding-right: 10px;
            }
        }
        .title::after {
            content: '';
            width: 100%;
            position: absolute;
            left: 0;
            bottom: 50%;
            height: 1px;
            background: #f4f4f5;
        }
        .duty,.requirement {
            margin-bottom: 5px;
            font-weight: 600;
        }
        .requirement {
            margin-top: 10px;
        }
        .detailed {
            padding: 0;
            margin: 0;
        }
    }
    .footer {
        margin-top: 20px;
        text-align: center;
    }
}
</style>
<style scoped>
.container >>> .el-empty__description p{
    font-size: 24px;
}
</style>
<style>
.max-box{
    width: 600px;
}
</style>
